<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />

    <b-card>
      
      <div class="ml-auto d-flex justify-content-between">
        <div></div>
        <div>
          <b-button
            @click="showAddHolidayModal"
            variant="success"
            v-can="{ slug: $route.meta.slug, action: 'C' }"
          >
            <feather-icon class="mx-25" icon="PlusIcon" />
            إضافة
          </b-button>
        </div>
      </div>
      <FullCalendar :options='calendarOptions' >
        <template v-slot:eventContent='arg'>
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
      
      <!-- <data-table
        @row-clicked="onRowCLicked"
        hover
        ep="v2/ministry/instructions"
        :fields="fields"
        :pagination="false"
        :hidePageSize="false"
        ref="instructionsTable"
      /> -->
      
    </b-card>
    <b-modal
      title="معلومات عطلة"
      centered
      v-model="editHolidayModal"
      footer-class="removed"
      no-close-on-backdrop
    >
      <div v-if="isEdit === false && isDelete === false">
        <p>اسم العطلة : <span>  {{form.name}} </span></p>
        <p>عدد أيام العطلة : <span>   {{form.total_duration}} </span></p>
        <p>تاريخ بداية العطلة : <span>   {{form.start_date}}</span></p>
        <p>تاريخ نهاية العطلة : <span>    {{form.end_date}}</span></p>
        <div class=" d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            @click="isEdit = true"
            class="mr-1"
            v-can="{ slug: $route.meta.slug, action: 'U' }"
          >
            <span class="mr-25 align-middle">تعديل</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            @click="isDelete = true"
            v-can="{ slug: $route.meta.slug, action: 'D' }"
          >
            <span class="mr-25 align-middle">حذف</span>
          </b-button>

        </div>
        
      </div>
      <div  v-if="isDelete === true"  >
        <p> هل أنت متأكد من حذف العطلة ؟</p>
        <hr />
          <div class="w-100 d-flex justify-content-end">
          
            <loader-btn
              label="حذف"
              loadingLabel="جارٍ الحذف ..."
              :loading="loading"
              variant="danger"
              type="submit"
              @click="onDeleteHolidayConfirmed"
            >
            </loader-btn>
          </div>
      </div>
      <b-form v-if="isEdit === true" @submit.prevent="onEditHolidayDialogConfirmed">
        <validation-observer ref="simpleRules">
          <form-input
            v-model="form.name"
            rules="required"
            label="اسم العطلة"
          />
          <form-input
            v-model="form.total_duration"
            rules="required|integer"
            label="عدد أيام العطلة"
          />
          <form-mask
            options="date"
            placeholder="YYYY-MM-DD"
            id="employment_date"
            v-model="form.start_date"
            label="تاريخ بداية العطلة"
            rules="required"
          />
          <form-mask
            options="date"
            placeholder="YYYY-MM-DD"
            id="employment_date"
            v-model="form.end_date"
            label="تاريخ نهاية العطلة"
            rules="required"
          />

          <hr />
          <div class="w-100 d-flex justify-content-end">
          
            <loader-btn
              label="تعديل"
              loadingLabel="جارٍ التعديل ..."
              :loading="loading"
              variant="success"
              type="submit"
              @click.prevent="onEditHolidayDialogConfirmed"
            >
            </loader-btn>
          </div>
        </validation-observer>
      </b-form>
    </b-modal>
    <form-modal
      title="إضافة عطلة"
      :form-schema="holidayFormSchema"
      v-model="addHolidayModal"
      :loading="loading"
      confirmLabel="حفظ"
      @confirm="onHolidayDialogConfirmed"
    >
    </form-modal>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import { BRow, BCol, BCard , BButton } from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import multiMonthPlugin from '@fullcalendar/multimonth'
import DataTable from "@/components/data-table/index.vue";
import SearchInput from "@/components/SearchInput.vue";
import debounce from "lodash.debounce";
import FormModal from "@/components/FormModal.vue";
import FormMask from "@/components/form-mask";
import FormInput from "@/components/form-input";
import LoaderBtn from "@/components/loader-btn.vue";
import { ValidationObserver } from "vee-validate";
import { required, integer } from '@validations';
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    FormMask,
    FormInput ,
    LoaderBtn ,
    ValidationObserver ,
    BButton,
    BRow,
    BCol,
    BCard,
    MinistryBreadcrumbs,
    DataTable,
    SearchInput,
    FormModal,
    FullCalendar 
  },

  data() {
    return {
      form: {
        id:'',
        name: '' ,
        total_duration : '' ,
        start_date : '' ,
        end_date : ''
      },
      isEdit:false,
      isDelete:false,
      editHolidayModal : false ,
      addHolidayModal: false,
      calendarOptions: {
        plugins: [multiMonthPlugin],
        initialView: 'multiMonthYear',
        eventClick: this.handleEventClick ,
        events: []
        
      } ,
      holidayFormSchema: {
        name: {
          key: "name",
          component: "FormInput",
          attrs: {
            label: "اسم العطلة",
            rules: "required",
          },
        },
        total_duration: {
          key: "total_duration",
          component: "FormInput",
          attrs: {
            label: "عدد أيام العطلة",
            rules:"required|integer" ,
          },
        },
        start_date: {
          component: "FormMask",
          key: "start_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ بداية العطلة",
            rules: "required",
          },
        },
        end_date: {
          component: "FormMask",
          key: "end_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ نهاية العطلة",
            rules: "required",
          },
        },
      },

      mainTitle: "أيام العطل الرسمية",
      search: "",
      fields: [
        {
          label: "المعرف",
          key: "id",
        },
        {
          label: "اسم الصفحة",
          key: "name",
        },
      ],
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "أيام العطل الرسمية",
          active: true,
        },
      ],
    };
  },
  watch: {
    search: debounce(function (val) {
      this.$refs.instructionsTable.setQueryParams({ name: val });
      this.$refs.instructionsTable.refreshTable();
    }, 500),
  },
 
  computed: {
    ...mapGetters("Ministry/Settings/Holidays", ["loading" , "holiday" , "holidays"]),
  }, 
  async mounted() {
    await this.fetchHolidays()
    for(let i = 0 ; i< this.holidays.length ; i++ ){
      this.calendarOptions.events.push (
          {
            title: this.holidays[i].name,
            start: this.holidays[i].start_date,
            end: this.holidays[i].end_date
          }
      )
    }
  },
  methods: {
    ...mapActions("Ministry/Settings/Holidays", ["addHoliday" , "fetchHoliday" , "fetchHolidays", "updateHoliday" , "deleteHoliday"]),
    onRowCLicked({ id }) {
      this.$router.push({ name: "settings-instructions-show", params: { id } });
    },
    showAddHolidayModal() {
      this.addHolidayModal = true;
        this.isEdit = false ;
        this.isDelete = false ;
    },
   
    async handleEventClick(info) {
      this.isEdit = false ;
      this.isDelete = false ;
      this.form.name = info.event.title
      
      this.editHolidayModal = true;
      await this.fetchHoliday(info.event.title).then(() => {
        this.form.id = this.holiday[0].id
        this.form.name = this.holiday[0].name
        this.form.start_date = this.holiday[0].start_date
        this.form.end_date = this.holiday[0].end_date
        this.form.total_duration = this.holiday[0].total_duration
      });
    } ,
    async onHolidayDialogConfirmed(form) {
      await this.addHoliday(form).then(() => {
        this.calendarOptions.events =[]
        for(let i = 0 ; i< this.holidays.length ; i++ ){
          this.calendarOptions.events.push (
              {
                title: this.holidays[i].name,
                start: this.holidays[i].start_date,
                end: this.holidays[i].end_date
              }
          )
        }
        this.addHolidayModal = false;
        this.isEdit = false ;
        this.isDelete = false ;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      });
    },
    async onDeleteHolidayConfirmed() {
      await this.deleteHoliday(this.form.id).then(() => {
        this.calendarOptions.events =[]
        for(let i = 0 ; i< this.holidays.length ; i++ ){
          this.calendarOptions.events.push (
              {
                title: this.holidays[i].name,
                start: this.holidays[i].start_date,
                end: this.holidays[i].end_date
              }
          )
        }
        this.editHolidayModal = false;
        this.isEdit = false ;
        this.isDelete = false ;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      });
    },
    async onEditHolidayDialogConfirmed(form) {
      await this.updateHoliday(this.form).then(() => {
        this.calendarOptions.events =[]
        for(let i = 0 ; i< this.holidays.length ; i++ ){
          this.calendarOptions.events.push (
              {
                title: this.holidays[i].name,
                start: this.holidays[i].start_date,
                end: this.holidays[i].end_date
              }
          )
        }
        this.editHolidayModal = false;
        this.form = {};
        this.isEdit = false ;
        this.isDelete = false ;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });

      });
    },
  },
};
</script>

<style>
i {
    color: #7a6ff1;
    margin: 3px;
}
.fc-event-main ,
.fc-direction-ltr .fc-daygrid-event.fc-event-end, .fc-direction-rtl .fc-daygrid-event.fc-event-start {
  color: #7a6ff1 !important;
  background-color: #e8e7fd !important; 
  text-align: center;
  overflow: hidden;

}
.fc-event-main{
    padding: 4px;
}
button.fc-today-button.fc-button.fc-button-primary  ,
.fc .fc-button-primary:disabled{
  display: none;
}
.fc-icon-chevron-left::before {
    content: "<";
}
.fc-icon-chevron-right::before {
    content: ">";
}
.fc .fc-toolbar.fc-header-toolbar{
  flex-direction: row-reverse; 
  margin-top: 15px;
}
.fc-direction-ltr .fc-toolbar > * > :not(:first-child){
  margin-left: 0px
}
.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child) , 
.fc-direction-ltr .fc-button-group > .fc-button:not(:first-child) {
  background: #95999e;
  border-color: #95999e;
}
</style>

